import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon, BarChart as BarChartIcon, Settings as SettingsIcon } from '@mui/icons-material';

const Navigation = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleHome = () => {
    if (user?.role === 'admin') {
      navigate('/agents');
    } else if (user?.role === 'agent') {
      navigate('/profile');
    }
  };

  const handleCallStatistics = () => {
    navigate('/call-statistics');
  };

  const handleSettings = () => {
    navigate('/settings');
  };

  if (!user) {
    return null;
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <Button
          color="inherit"
          startIcon={<HomeIcon />}
          onClick={handleHome}
          sx={{ mr: 2 }}
        >
          Home
        </Button>
        <Button
          color="inherit"
          startIcon={<BarChartIcon />}
          onClick={handleCallStatistics}
          sx={{ mr: 2 }}
        >
          Reports
        </Button>
        {user?.role === 'admin' && (
          <Button
            color="inherit"
            startIcon={<SettingsIcon />}
            onClick={handleSettings}
            sx={{ mr: 2 }}
          >
            Settings
          </Button>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body1" component="span" sx={{ fontWeight: 'medium' }}>
            {user.name || (user.role === 'admin' ? 'Admin' : 'Agent')}
          </Typography>
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation; 